import React, {Component} from 'react';
import PropTypes from 'prop-types';

import './Policy.scss'
import PolicyList from "./PolicyList";
import {inject, observer} from "mobx-react";

@observer
class PolicyPanel extends Component {

    onHeadingClicked = (e) => {

        let policyCatOuter = e.target;
        while (!policyCatOuter.classList.contains('policy__set')) {
            policyCatOuter = policyCatOuter.parentElement;
        }

        let plusSign = policyCatOuter.querySelector('.header__plusSign');
        plusSign.classList.toggle('is-open');

        const list = policyCatOuter.querySelector('.policy__list');
        const height = 48 + list.children[0].clientHeight + 'px';

        list.classList.toggle('is-expanded');
        if (list.classList.contains('is-expanded')) {
            list.style.maxHeight = height;
        } else {
            list.style.maxHeight = 0;
        }
    };

    render() {
        const {policies, polInPlay, policyValueChanged, countryName, isDelegate, hasChanged, metrics, alias, hasGameStarted, gameHasAdvanced} = this.props;
        const roleAssignment = metrics.metrics['role_policy_assignment'];
        let categories = [...new Set(policies.policies.map(pol => pol.category))];

        // console.log('roleassignment', roleAssignment);
        // console.log('categories', categories);
        // console.log('cat', cat =>cat.includes('ATG'));
        // console.log('alias', alias);

        // if (isDelegate) {
        //     categories = categories.filter(cat => cat.includes('ATG'));
        // } else {
        //     categories = categories.filter(cat => !cat.includes('ATG'))
        // }


        if (alias === 'PM') {
            categories = categories.filter(cat => !cat.includes('ATG'));
        } else {
            categories = categories.filter(cat => cat.includes(alias));
        }


        // console.log('roleassignment', roleAssignment);

        return (
            categories.map(cat => {
                const policyList = policies.policies.filter(pol => pol.category === cat && pol.country_name === countryName);
                return (
                    <ul className="policy__set" key={cat}>
                        <li className="ps__title pl1 pr1 flex relative" onClick={this.onHeadingClicked}>
                            <h3 className="flex flex-auto unlist flex-justify-between">
                                {cat} {roleAssignment && roleAssignment[cat] === alias && "(Your responsibility)"}
                                <div className="relative header__plusSign">
                                    <span className="absolute fit-x ma header__plusSignBar"/>
                                    <span className="absolute fit-x ma header__plusSignBar"/>
                                </div>
                            </h3>
                        </li>
                        <PolicyList policyList={policyList} policyValueChanged={policyValueChanged}
                                    polInPlay={polInPlay} hasChanged={hasChanged} hasGameStarted={hasGameStarted} gameHasAdvanced={gameHasAdvanced}/>
                    </ul>
                )
            })
        )
    }
}

PolicyPanel.propTypes = {
    countryName: PropTypes.string.isRequired,
    polInPlay: PropTypes.array.isRequired,
    policyValueChanged: PropTypes.func.isRequired,
    isDelegate: PropTypes.bool,
    hasChanged: PropTypes.bool,
    alias: PropTypes.string.isRequired,
};

export default inject('policies', 'metrics')(PolicyPanel);
